import { combineReducers } from 'redux';
import pages from './pages';
import entities from './entities';
import themes from './themes';
import themeListing from './theme_listing';
import banners from './banners';

const website = combineReducers({
  banners,
  pages,
  entities,
  themes,
  themeListing,
});

export default website;



// WEBPACK FOOTER //
// ./src/reducers/website/index.js